import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path className="cls-1" d="M223.2,106.5s0,0,0,0" />
    <g>
      <path
        className="cls-1"
        d="M100.6,61.9c-.3-.7-1.7-2-2.4-1.9-.7.2-2,1-2.5,1.6-16.2,18.4-13,42.4-11.1,42l3.2-.6c5.9-5.7,12.6-9.4,20.9-11.7,1.4-1.2,3-2.5,3.2-3.6.2-1.1-.7-3.4-1.3-4.6l-10-21.2Z"
      />
      <path
        className="cls-1"
        d="M161.7,127.4c5.8,2.3,5.5,8.5,9.9,11.1,2.7-5.2,1.3-9.2-.9-13.6-2.4-4.8-8.2-7.3-13.6-6.2-7.8,1.6-13.4,11.1-10,17.5l6.4-6.8c1.6-1.7,6.2-2.8,8.3-1.9Z"
      />
      <path
        className="cls-1"
        d="M244.5,112.2c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44-18.3-10.5-71.5-16.5-71.5-16.5-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-16.8,27.2-23.9,58.8-18.3,89.3,2.5,13.9,8.7,25.7,18.7,35.6l7.1-3.9c2.9-1.5,4-4,4-6.9l.2-23.2c.2-23.8,9.2-46.1,24.8-64.3,1.3-3.8,2.5-8.1,3.3-11.9,6-28.1,29.9-51.5,33.3-45l6.3,12.1c3.5,6.8,6.3,13,10.8,19.3,3.1,4.2,20.8-1,43.5,10.4,12.7,6.4,20.2,17.6,22.8,31.4,1.4,7.8,5,14.7,11.2,19.5l6.8,5.3c.8.6,1.8,2.6,1.7,3.5-.2,3-7.4.8-9.6,2.6-4.5,3.8,7.1,9.9,6,14.7-3.3,15.9-17,25.1-32.7,25.7-12.3.4-23.6,4.5-27.2,16.2-2.1,6.9-1.1,13.5,3,18.8,1.3,1.7,2.7,3.1,4.4,4.2h0c9.6-.5,18.9-1.7,26.7-3.7,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
      />
    </g>
  </svg>
);
export default SVGComponent;
